/**
 * Display a list of Alias chips.
 */

import React from 'react';

// @todo: Migrate to 'AliasGroup' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Alias, AliasInfo} from './Alias';

type AliasesProps = {
  aliases: AliasInfo[];
};

export const Aliases = ({aliases}: AliasesProps) => {
  // TODO: Sort version first or last?
  return (
    <>
      {aliases.map(a => (
        <Alias key={a.alias} alias={a} />
      ))}
    </>
  );
};
